import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import FinSupplierCardDTO from 'src/app/invopay/interfaces/fin-supplier-card-dto';
import { FnBlockCardModalComponent } from '../fn-block-card-modal/fn-block-card-modal.component';

@Component({
  selector: 'app-fn-card-image',
  templateUrl: './fn-card-image.component.html',
  styleUrls: ['./fn-card-image.component.scss']
})
export class FnCardImageComponent implements OnInit {
  @Input() cardInfo?: FinSupplierCardDTO;
  @Input() supplierId?: number;
  @Output() cardBlocked = new EventEmitter<any>();
  actions: string[] = [];
  isMenuOpen: boolean = false;
  @ViewChild('toggleButton') toggleButton!: ElementRef;
  @ViewChild('menu') menu!: ElementRef;

  constructor(
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    this.actions = ['newCard'];
    if (this.cardInfo?.cardStatus !== 'BLOCKED') {
      this.actions.push('blockCard');
    }
    this.renderer.listen('window', 'click', (e: Event) => {
      if (
        e.target !== this.toggleButton.nativeElement &&
        e.target !== this.menu.nativeElement
      ) {
        this.isMenuOpen = false;
      }
    });
  }

  // TODO: get brand from the backend
  // (checking the card number is not realiable on MOCK data)
  checkIfItsVisa(cardName: string) {
    return (
      cardName.includes('visa') ||
      cardName.includes('Visa') ||
      cardName.includes('VISA'));
  }

  toggleMenuOpen() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  onAction(action: string) {
    switch (action) {
      case 'blockCard':
        const dialogRef = this.dialog.open(FnBlockCardModalComponent, {
          height: 'max-content',
          maxWidth: 'none',
          panelClass: 'custom-modal',
          data: {
            supplierId: this.supplierId,
          }
        });
        dialogRef.afterClosed().subscribe((blocked: boolean) => {
          if (blocked) {
            this.actions = ['newCard'];
            this.cardBlocked.emit();
          }
        });
        break;
    }
  }

  formatCardNumber(cardNumber: string): string {
    const cardNumberParts = [];
    for (let i = 0, j = 0; i < 4; i++) {
      cardNumberParts[i] = cardNumber.substring(j, j + 4);
      j += 4;
    }
    return cardNumberParts[3]
  }

  formatDate(date: string): string {
    const month = this.datePipe.transform(date, 'MM');
    const year = this.datePipe.transform(date, 'yy');
    return `${month}/${year}`;
  }
}
